export default __webpack_public_path__ + "static/media/inclusion.1026fbeb.png";